module.exports = __webpack_public_path__ + "img/ceramic@2x.147fd19.webp";